import ReactDOM from "react-dom/client";

import App from "./App";
import "./index.css";
import React from "react";

// Render App component in root
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
